module.exports = __webpack_public_path__ + "assets/8a651d1a72685969d92c748963be18cb.mp3";